import React, { Component } from 'react';
import * as axios from 'axios';
import * as moment from 'moment';
import './NewsOverview.scss';

//import $ from 'jquery';
import 'slick-carousel/slick/slick.js';
import 'dotdotdot-js/dist/dotdotdot.js';

declare var jQuery: any;
//declare var jquery: any;
//declare var $: JQueryStatic;

//import $ from 'jquery';
//window.jQuery = $;
//window.$ = $;

class NewsOverview extends Component {
  

  isVideo() {
    if(this.props.data.videoUrl) {
      return ' video';
    } else {
      return '';
    }
    //search-api/news/_search?query_string=*
  }

  constructor(props) {
    super(props);
    this.parentNode = null;
    this.state = {
      data: {
        hits: {
          hits: []
        }

      }
    };

  }

  componentDidMount() {
    let paramsBody = {
      'from': (this.props.data.from)? parseInt(this.props.data.from, 10): 0,
      'size': (this.props.data.size)? parseInt(this.props.data.size, 10): 4,
      'query': {
        "bool": {
          "must": [
            {
              'query_string': {
                'query': (this.props.data.query)? this.props.data.query: '*'
              }
            }
          ]
        }
      }
    };
    let sortBy = {};
    let sortByField = (this.props.data.sortField)? this.props.data.sortField: 'title';
    sortBy[sortByField] = { 
      'order': (this.props.data.sortOrder)? this.props.data.sortOrder: 'desc'
    };

    if(typeof this.props.data.audience !== 'undefined') {
      let audience = this.props.data.audience.split(',');
      audience.forEach(function(element) {
        paramsBody.query.bool.must.push( {term : {
          audience: jQuery.trim(element)
        }});
      });
      
    }

    paramsBody.sort = [sortBy];
    
    axios({
      method: 'POST',
      url: '/search-api/'+this.props.data.site+'/'+this.props.data.contentType+'/_search',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(paramsBody)
    }).then((response) => {
      this.setState({ data: response.data},() => {
        jQuery('.newsOverview .item-title').each(function() {
          jQuery(this).dotdotdot({});
        })

      })
    })
    .catch((error) => {
      //console.log(error);
    });
    
  }

  setupTruncates() {
//    console.log('dsakldsjel');
   /* $(this.parentNode).find('.item-title').each(function(item,k)  { 
      var thisNode = $(this);
      var width = $($(this).parent()).width();
      thisNode.css({ maxWidth: width+'px' });
    });*/
  }


  // and or
  componentDidUpdate() {
    //this.setupTruncates();
  }
  dateFormat(dateTime) {
   //return dateTime;
    return moment(dateTime,'X').format("dddd, MMMM Do YYYY");
  }
  getHref(href) {
    //console.log(typeof href, href)
    if(typeof href === 'string'){
      return href;
    } else {
      return '#';  
    }
   
  }

  espaceChars(text) {
    return text.replace(/"/g, '&quot;');
  }

  render() {
    
    return (
      
      <div ref={(input) => { this.parentNode = input; }} >
          <h3 className="title">{this.props.data.header}</h3>
          <div className="items">
              {this.state.data.hits.hits.map((d,i) => { 
                let featured = d._source.featured_image_square_thumbnail
                if(this.props.data.style === 'featured' && i === 0) {
                  featured = d._source.featured_image_16x9__640x360_;
                }
                return (<a key={i} href={this.getHref(d._source.base_url+d._source.alias)}>

                    <div className="item">
                        <div className="left-container">
                            <img className="picture" src={featured} alt={this.espaceChars(d._source.title)}/>
                        </div>
                        <div className="content">
                            <div className="date">{this.dateFormat(d._source.story_date)}</div>
                            <h4 className="item-title" >{d._source.title}</h4>
                        </div>
                    </div>
                </a>)
              })}
          </div>

          <a href={this.props.data.sourceWebsite} className="button primary">View All News</a>
      </div>

    );
  }
}

export default NewsOverview;



// WEBPACK FOOTER //
// ./src/NewsOverview/NewsOverview.js